module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-content', {
    staticClass: "center-panel md-elevation-1",
    attrs: {
      "id": "login-form",
      "md-theme": "white"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-1 md-accent message"
  }, [_vm._v("Укажите новый логин и пароль")]), _c('div', [_c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('password')
    }
  }, [_c('label', [_vm._v("Новый пароль")]), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "password",
      "data-vv-name": "' '"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])], 1), _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('password_confirm')
    }
  }, [_c('label', [_vm._v("Повторите пароль")]), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "password_confirm",
      "data-vv-name": "' '"
    },
    model: {
      value: (_vm.form.password_confirm),
      callback: function($$v) {
        _vm.$set(_vm.form, "password_confirm", $$v)
      },
      expression: "form.password_confirm"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password_confirm')),
      expression: "errors.has('password_confirm')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirm')))])], 1), (_vm.message) ? _c('md-content', {
    staticClass: "md-elevation-1 md-accent message"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _c('div', {
    staticClass: "md-layout md-gutter md-alignment-center-right"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Отправить")])], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Авторизоваться")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ef2466d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/ResetPasswordConfirm.vue
// module id = 1159
// module chunks = 0